import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ILegacyRecords } from 'src/app/common/models/ILegacyRecords';
import { ClearLegacyRecords, SetLegacyRecordsData } from './legacy-records.actions';

export class LegacyRecordsStateModel {
  data: ILegacyRecords;
}


@State<LegacyRecordsStateModel>({
  name: 'legacyRecords',
  defaults: {
    data: null
  }
})

@Injectable()
export class LegacyRecordsState {

    @Selector()
    static getLegacyRecordsState(state: LegacyRecordsStateModel) {
        return state;
    }

    @Action(SetLegacyRecordsData)
    public setLegacyRecords({ getState, setState }: StateContext<LegacyRecordsStateModel>,
       { data }: SetLegacyRecordsData) {
        const state = getState();
        setState({ ...state, data });
    }

    @Action(ClearLegacyRecords)
    public clearLegacyRecords({ getState, setState }: StateContext<LegacyRecordsStateModel>) {
        const state = getState();
        setState({ ...state, data: null });
    }

}
